/* eslint-disable arrow-body-style */
import { useIntl } from 'umi';
import { deleteHistory } from '../../../service/service';
import { notification } from 'tea-component';
import { v4 as uuidv4 } from 'uuid';
import { useSessionId } from '../../hooks/useAgentModalSata';
interface Iprops {
  // 用户信息
  userInfo: any;
  // 编辑时需要删除的消息id数组
  deleteMessageIds: any;
  // 提交编辑
  handleSubmit: any;
  // 问题
  question?: any;
  // 附件列表
  fileList?: any;
  // 对话列表，用于查找目标消息的 mode / model_id / metadata / frontend_metadata
  conversations?: any[];
  // 当前消息 id，用于在 conversations 中定位目标消息
  messageId?: string;
  // 当前消息的前端元数据，用于还原 queryTabs 等技能上下文
  frontend_metadata?: any;
}

const useRefreshHooks = (props: Iprops) => {
  const {
    userInfo,
    deleteMessageIds,
    question,
    handleSubmit,
    fileList,
    conversations,
    messageId,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    frontend_metadata,
  } = props;
  // const [isRefresh, setIsRefresh] = useState(false);
  const { formatMessage } = useIntl();
  const { sessionId: routeSessionId } = useSessionId();
  const { openid } = userInfo || {};

  /**
   * 处理编辑确认操作
   * @param value - 编辑后的值
   * @description 
   * 1. 关闭编辑状态
   * 2. 调用删除历史记录接口
   * 3. 提交编辑后的内容
   * 4. 错误时显示通知
   */
  const handleRefreshConfirm = async () => {
    // setIsRefresh(false);
    try {
      await deleteHistory({
        sessionId: routeSessionId,
        openId: openid,
        messageIds: deleteMessageIds,
        traceId: uuidv4(),
      });

      // 在 conversations 中定位目标消息，提取服务端需要的参数
      const targetIndex = conversations?.findIndex(
        (item: any) => item?.messageId === messageId,
      ) ?? -1;
      const targetMessage = targetIndex !== -1 ? conversations?.[targetIndex] : null;

      const serverProps = {
        mode: targetMessage?.mode,
        model_id: targetMessage?.modeId,
        // 透传 target 原始 frontend_metadata（含 isSkillInherited），
        // 由 getEffectiveSkills 在 refresh 分支直接据此决定 isInherited
        frontend_metadata: targetMessage?.frontend_metadata,
        ...(targetMessage?.metadata || {}),
      };

      // 始终按当轮 target 的 queryTabs 发给服务端，保证 skill_config 参数完整；
      // 至于输入框是否展示 skill 标签（isSkillInherited），由 getEffectiveSkills
      // 通过 deleteMessageIds 定位 target 原消息后自行判定
      const selectedSkills = targetMessage?.frontend_metadata?.queryTabs
        || frontend_metadata?.queryTabs
        || [];

      // 使用新的格式化函数处理历史消息
      handleSubmit({
        value: question,
        fileList,
        options: {},
        from: 'refresh',
        deleteMessageIds,
        serverProps,
        mentionConfig: {
          selectedSkills,
        },
      });
    } catch (error) {
      // 错误处理逻辑（如果需要）
      notification.error({
        description: formatMessage({ id: 'dba_common_refresh_failed' }),
        duration: 2000,
      });
    }
  };


  return {
    handleRefreshConfirm,
  };
};
export default useRefreshHooks;
